import React from "react";
import DashboardLayout from "./DashboardLayout";

// Use absolute URLs for navigation
const icons = {
  jobs: (
    <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
      <rect x="3" y="7" width="18" height="13" rx="2" fill="#2563eb" />
      <path
        d="M8 7V5a4 4 0 0 1 8 0v2"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  blogs: (
    <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
      <rect x="4" y="3" width="16" height="18" rx="2" fill="#059669" />
      <rect x="7" y="7" width="10" height="2" rx="1" fill="#fff" />
      <rect x="7" y="11" width="10" height="2" rx="1" fill="#fff" />
      <rect x="7" y="15" width="6" height="2" rx="1" fill="#fff" />
    </svg>
  ),
  users: (
    <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" fill="#f59e42" />
      <rect x="4" y="15" width="16" height="5" rx="2.5" fill="#f59e42" />
    </svg>
  ),
  info: (
    <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="#a21caf" />
      <rect x="11" y="10" width="2" height="6" rx="1" fill="#fff" />
      <rect x="11" y="7" width="2" height="2" rx="1" fill="#fff" />
    </svg>
  ),
};

const dashboardCards = [
  {
    key: "jobs",
    label: "Total Jobs",
    value: 12,
    icon: icons.jobs,
    color: "#2563eb",
    info: "Number of job postings currently active.",
    url: "#",
  },
  {
    key: "blogs",
    label: "Total Blogs",
    value: 8,
    icon: icons.blogs,  
    color: "#059669",
    info: "Number of published blogs.",
    url: "#",
  },
  // {
  //   key: "users",
  //   label: "Total Users",
  //   value: 102,
  //   icon: icons.users,
  //   color: "#f59e42",
  //   info: "Registered users in the system.",
  //   // No url for users
  // },
  {
    key: "info",
    label: "Info Requests",
    value: 3,
    icon: icons.info,
    color: "#a21caf",
    info: "Pending information requests.",
    // No url for info
  },
];

const DashboardHome: React.FC = () => {
  // Handle card click for navigation
  const handleCardClick = (url?: string) => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <DashboardLayout>
      <div
        style={{
          fontSize: "2rem",
          fontWeight: 700,
          marginBottom: "1.5rem",
          color: "#222",
        }}
      >
        Welcome to Admin Dashboard Home!
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "2rem",
          marginTop: "2rem",
        }}
      >
        {dashboardCards.map((card) => (
          <div
            key={card.key}
            style={{
              background: "#f3f4f6",
              borderRadius: "1.25rem",
              padding: "2rem",
              minWidth: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              position: "relative",
              transition: "box-shadow 0.2s",
              cursor: card.url ? "pointer" : "default",
            }}
            tabIndex={0}
            aria-label={card.label}
            onMouseOver={(e) => {
              (e.currentTarget as HTMLDivElement).style.boxShadow =
                "0 4px 24px rgba(0,0,0,0.10)";
            }}
            onMouseOut={(e) => {
              (e.currentTarget as HTMLDivElement).style.boxShadow =
                "0 2px 12px rgba(0,0,0,0.06)";
            }}
            onClick={() => handleCardClick(card.url)}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: card.color,
                color: "#fff",
                borderRadius: "50%",
                width: "56px",
                height: "56px",
                fontSize: "2.2rem",
                marginBottom: "1rem",
                boxShadow: `0 2px 8px ${card.color}33`,
              }}
            >
              {card.icon}
            </span>
            <div style={{ fontSize: "1.1rem", fontWeight: 600, color: "#444" }}>
              {card.label}
            </div>
            <div
              style={{
                fontSize: "2.2rem",
                fontWeight: 800,
                color: card.color,
                margin: "0.5rem 0",
              }}
            >
              {card.value}
            </div>
            <a
              href={card.url ? card.url : undefined}
              target={card.url ? "_blank" : undefined}
              rel={card.url ? "noopener noreferrer" : undefined}
              style={{ width: "100%", textDecoration: "none" }}
              tabIndex={-1}
              onClick={(e) => {
                // Prevent anchor navigation if no url
                if (!card.url) e.preventDefault();
                // Prevent bubbling to card click if url exists (so only one navigation)
                if (card.url) e.stopPropagation();
              }}
            >
              <div
                style={{
                  fontSize: "0.98rem",
                  color: "#666",
                  marginTop: "0.5rem",
                  background: "#fff",
                  borderRadius: "0.5rem",
                  padding: "0.5rem 0.75rem",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                  minHeight: "2.2rem",
                  width: "100%",
                  cursor: card.url ? "pointer" : "default",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.4rem",
                  }}
                >
                  <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      fill={card.color}
                      opacity="0.15"
                    />
                    <path
                      d="M12 8v4"
                      stroke={card.color}
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <circle cx="12" cy="16" r="1" fill={card.color} />
                  </svg>
                  {card.info}
                </span>
              </div>
            </a>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
};

export default DashboardHome;
